import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link as RouterLink, browserHistory } from 'react-router';
import Toggle from 'react-toggle';
import { Helmet } from 'react-helmet';
import { Link } from '@zola/zola-ui';

import { getUserContext, updateUserStatus } from '../../actions/UserActions';
import { fetchWeddingAccount, fetchWedding, toggleWebsite } from '../../actions/WeddingActions';
import { fetchRegistry, updateRegistryPublish } from '../../actions/RegistryActions';
import { showModal } from '../../actions/ModalActions';

import SearchSettingsForm from './privacy/SearchSettingsForm';
import PasswordSettingsForm from './privacy/PasswordSettingsForm';
import GuestRSVPSettingsForm from './privacy/GuestRSVPSettingsForm';

import '../../stylesheets/pages/settings/PrivacySettings.less';

class PrivacySettings extends Component {
  constructor(props) {
    super(props);
    this.handleToggleRegistryPublish = this.handleToggleRegistryPublish.bind(this);
    this.handleToggleWebsitePublish = this.handleToggleWebsitePublish.bind(this);
  }

  componentDidMount() {
    const { handleGetUserContext, handleFetchWeddingAccount, handleFetchWedding, handleFetchRegistryAccount } = this.props;
    handleGetUserContext().then(() => {
      const { userContext } = this.props;
      handleFetchWedding();
      if (userContext.has_wedding_account) {
        handleFetchWeddingAccount();
      }
      if (userContext.has_registry) {
        handleFetchRegistryAccount();
      }
    });
  }

  handleToggleWebsitePublish() {
    const { websiteVisibility, onToggleWebsitePublish, openHidePagesModal, handleUpdateUserStatus } = this.props;

    handleUpdateUserStatus().then((userStatus) => {
      if (userStatus.payload.status !== 'IDLE') {
        if (websiteVisibility) {
          onToggleWebsitePublish(false);
        } else {
          openHidePagesModal();
        }
      } else {
        browserHistory.push({ pathname: '/wedding/login', state: { referralPage: window.location.pathname } });
      }
    });
  }

  handleToggleRegistryPublish() {
    const { registryAccount, registryVisibility, setShippingAddress, onPublishRegistry, onHideRegistry, handleUpdateUserStatus } = this.props;

    handleUpdateUserStatus().then((userStatus) => {
      if (userStatus.payload.status !== 'IDLE') {
        if (!registryVisibility) {
          if (!registryAccount.has_shipping_address) {
            setShippingAddress();
          } else {
            onPublishRegistry();
          }
        } else {
          onHideRegistry();
        }
      } else {
        browserHistory.push({ pathname: '/wedding/login', state: { referralPage: window.location.pathname } });
      }
    });
  }

  render() {
    const { websiteVisibility, registryVisibility, userContext, searchSettingsVisibility } = this.props;
    const hasWebsite = userContext.has_wedding_account;
    const hasRegistry = userContext.has_registry;
    const slug = userContext.user_role_account_weddings && userContext.user_role_account_weddings[0].slug;

    return (
      <div id="privacy-settings-page" className="settings-page-container margin-bottom">
        <Helmet defaultTitle="Privacy Settings" />
        <h1 className="settings-page-header">Privacy Settings</h1>
        <div className="visibility-settings">
          <h3>Visibility</h3>
          {hasWebsite && (
            <div className="visibility-item">
              <div className="toggle">
                <Toggle
                  checked={websiteVisibility}
                  className="visibility-toggle"
                  icons={false}
                  onChange={this.handleToggleWebsitePublish}
                />
              </div>
              <div>
                { websiteVisibility ? (
                  <div>
                    <p><strong>Website is <span className="visible">Visible</span></strong></p>
                    <p>Guests can see your website.</p>
                    <p><RouterLink className="zola-ui link link-arrow" to={`/wedding/${slug}`}>View Website</RouterLink></p>
                    <br />
                  </div>
                ) : (
                  <div>
                    <p><strong>Website is <span className="not-visible">Not Visible</span></strong></p>
                    <p>Guests cannot see your website.</p>
                    <p><RouterLink className="zola-ui link link-arrow" to="/wedding/manage/website/manage">Manage Website</RouterLink></p>
                    <br />
                  </div>
                )}
              </div>
            </div>
          )}
          {hasRegistry && (
            <div className="visibility-item">
              <div className="toggle">
                <Toggle
                  checked={registryVisibility}
                  className="visibility-toggle"
                  icons={false}
                  onChange={this.handleToggleRegistryPublish}
                />
              </div>
              { registryVisibility ? (
                <div>
                  <p><strong>Registry is <span className="visible">Visible</span></strong></p>
                  <p>Guests can visit and shop your registry.</p>
                  <p><Link arrow href={`/registry/${slug}?preview=true`}>View Registry</Link></p>
                </div>
              ) : (
                <div>
                  <p><strong>Registry is <span className="not-visible">Not Visible</span></strong></p>
                  <p>Guests cannot visit or shop your registry.</p>
                  <p><Link arrow href="/my-registry" onClick={this.handleRegistryPublish}>Manage Registry</Link></p>
                </div>
              )}
            </div>
          )}
        </div>
        <hr />
        <div>
          <h3>Search Settings</h3>
          { searchSettingsVisibility ? (
            <SearchSettingsForm hasWebsite hasRegistry websiteVisibility registryVisibility />
          ) : (
            <div>
              <p>Once you make your wedding website and/or registry visible to guests, you can control your search settings. Until then, no one can find your pages.</p>
            </div>
          )}
        </div>
        {hasWebsite && (
        <div>
          <hr />
          <h3>Website Password</h3>
          <PasswordSettingsForm />
          <hr />
          <div>
            <h3>Guest RSVP</h3>
            <GuestRSVPSettingsForm />
          </div>
        </div>
        )}
      </div>
    );
  }
}

PrivacySettings.propTypes = {
  userContext: PropTypes.shape({}).isRequired,
  handleGetUserContext: PropTypes.func,
  handleFetchWedding: PropTypes.func,
  handleFetchWeddingAccount: PropTypes.func,
  handleFetchRegistryAccount: PropTypes.func,
  onHideRegistry: PropTypes.func,
  onPublishRegistry: PropTypes.func,
  setShippingAddress: PropTypes.func,
  weddingAccount: PropTypes.shape({}),
  wedding: PropTypes.shape({}),
  registryAccount: PropTypes.shape({}),
  onToggleWebsitePublish: PropTypes.func,
  openHidePagesModal: PropTypes.func,
  websiteVisibility: PropTypes.bool,
  registryVisibility: PropTypes.bool,
  searchSettingsVisibility: PropTypes.bool,
  handleUpdateUserStatus: PropTypes.func,
};

const mapStateToProps = state => ({
  userContext: state.user.userContext,
  weddingAccount: state.wedding.account,
  wedding: state.wedding.wedding,
  registryAccount: state.registry,
  websiteVisibility: state.wedding.account.published || false, // set default to avoid uncontrollled component error while undefined.
  registryVisibility: state.registry.is_public || false,
  searchSettingsVisibility: state.wedding.account.published || state.registry.is_public,
});

const mapDispatchToProps = dispatch => ({
  handleGetUserContext: () => dispatch(getUserContext()),
  handleFetchWedding: () => dispatch(fetchWedding()),
  handleFetchWeddingAccount: () => dispatch(fetchWeddingAccount()),
  handleFetchRegistryAccount: () => dispatch(fetchRegistry()),
  onHideRegistry: () => dispatch(updateRegistryPublish(false)),
  onPublishRegistry: () => dispatch(updateRegistryPublish(true)).then(() => dispatch(showModal('PUBLISH_REGISTRY', {}, { size: 'md' }))),
  setShippingAddress: () => dispatch(showModal('SET_SHIPPING_ADDRESS', {}, { size: 'md' })),
  openHidePagesModal: () => dispatch(showModal('HIDE_PAGES', {}, { size: 'md' })),
  onToggleWebsitePublish: publish => dispatch(toggleWebsite(publish)),
  handleUpdateUserStatus: () => dispatch(updateUserStatus())
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivacySettings);



// WEBPACK FOOTER //
// ./src/components/settings/PrivacySettings.jsx